export default "__VITE_ASSET__Bit3bAXD__"